/** Reading what the API said when a call failed, and tidying what we send it. */

interface ApiError {
  response?: { status?: number; data?: { detail?: unknown } };
}

/** The server's own reason when it gave one, else the fallback. */
export function apiErrorMessage(err: unknown, fallback: string): string {
  const detail = (err as ApiError).response?.data?.detail;
  if (typeof detail === 'string' && detail) return detail;
  if (Array.isArray(detail)) {
    // Pydantic lists each field that was refused.
    const reasons = detail
      .map((d: { loc?: unknown[]; msg?: string }) => {
        const field = Array.isArray(d.loc) ? String(d.loc[d.loc.length - 1]) : '';
        const msg = (d.msg ?? '').replace(/^Value error, /, '');
        return field ? `${field.replace(/_/g, ' ')}: ${msg}` : msg;
      })
      .filter(Boolean);
    if (reasons.length) return reasons.join('. ');
  }
  return fallback;
}

export function isNotFound(err: unknown): boolean {
  return (err as ApiError).response?.status === 404;
}

/** A trimmed text field; blank means none. */
export function blankToNull(value: string): string | null {
  const trimmed = value.trim();
  return trimmed ? trimmed : null;
}
